import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class Dispertion extends ActionCard {
    static typeId = "DISPERSION";
    static cardName = "Dispersion !";
    static colorHex = "#64C864";
    static countInDeck = ACTION_CARD_COUNTS.DISPERSION;
    static description = "Retire toute la ligne et mélange les moutons."

    isValidOn(slotIndex, gameState) {
        // Always valid on any slot
        return true;
    }

    resolve(slotIndex, gameState) {
        gameState.dispersion();
    }
}
